import React, { useState, useContext, useEffect } from "react";
import "./meetingSummary.css";
import DatePicker from "react-datepicker";

// ---------------------------------------------------------------------React Icons--------------------------------------------------------------------------------
import {
  FaPlusSquare,
  FaCheck,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaTrash,
  FaEdit,
  FaFilter,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaMinus,
  FaSave,
  FaSearch,
  FaThList,
} from "react-icons/fa";
import { BsSearch } from "react-icons/bs";
import HrMeetings from "./HrMeetings";
import ItMeegings from "./ItMeetings";
import GovernanceMeetings from "./GovernanceMeetings";
import FacillityMeetings from "./FacillityMeetings";

// ---------------------------------------------------------------------Context Data--------------------------------------------------------------------------------
import { contextData } from "../../../../context/ContextProvider";
import ViewPastMeetings from "../MyMeetings/PastMeetings/ViewPastMeetings";
import moment from "moment";
import { createTableIcons } from "../../../CommonCase/CommonFunctions";

export const handleActiveTag = (tag, setActiveTag, setSearchInp) => {
  switch (tag) {
    case "HR":
      setActiveTag("HR");
      setSearchInp("")
      break;
    case "IT":
      setActiveTag("IT");
      setSearchInp("")
      break;
    case "GO":
      setActiveTag("GO");
      setSearchInp("")
      break;
    case "FA":
      setActiveTag("FA");
      setSearchInp("")
      break;
    default:
      setActiveTag("HR");
      setSearchInp("")
  }
};

export const handleDateChange = (
  name,
  date,
  setSelectedFromDate,
  setSelectedToDate
) => {
  if (name == "ToDate") {
    setSelectedToDate(date);
  } else {
    setSelectedFromDate(date);
  }
};

export const handleOnChange = (
  date,
  selectedFromDate,
  handleDateChange,
  setSelectedFromDate,
  setSelectedToDate
) => {
  const selectedFromTimestamp = selectedFromDate?.getTime();
  const dateTimestamp = date?.getTime();

  if (selectedFromTimestamp !== dateTimestamp) {
    handleDateChange("FromDate", date, setSelectedFromDate, setSelectedToDate);
  }
};

export const handleToDateChange = (
  date,
  selectedToDate,
  handleDateChange,
  setSelectedFromDate,
  setSelectedToDate
) => {
  const selectedToTimestamp = selectedToDate?.getTime();
  const dateTimestamp = date?.getTime();

  if (selectedToTimestamp !== dateTimestamp) {
    handleDateChange("ToDate", date, setSelectedFromDate, setSelectedToDate);
  }
};



const MeetingSummary = () => {
  const tableIcons1 = createTableIcons("#6E0096");
  const tableIcons2 = createTableIcons("#1CA566");
  const tableIcons3 = createTableIcons("#057DAA");
  const tableIcons4 = createTableIcons("#FF9B00");

  const [activeTag, setActiveTag] = useState("HR");

  const { viewPastMeeting } = useContext(contextData);

  const [selectedPeriod, setSelectedPeriod] = useState("Monthly");
  const [searchInp, setSearchInp] = useState("");

  const [selectedToDate, setSelectedToDate] = useState("");
  const [selectedFromDate, setSelectedFromDate] = useState("");
  const [openToDatePicker, setOpenToDatePicker] = useState(false);
  const [openFromDatePicker, setOpenFromDatePicker] = useState(false);

  // ----------------------------------------------------------------------------------Table-------------------------------------------------------------------------------

  const tagComponents = {
    HR: (
      <HrMeetings
        tableIcons={tableIcons1}
        selectedPeriod={selectedPeriod}
        searchInp={searchInp}
        selectedToDate={selectedToDate}
        selectedFromDate={selectedFromDate}
      />
    ),
    IT: (
      <ItMeegings
        tableIcons={tableIcons2}
        selectedPeriod={selectedPeriod}
        searchInp={searchInp}
        selectedToDate={selectedToDate}
        selectedFromDate={selectedFromDate}
      />
    ),
    GO: (
      <GovernanceMeetings
        tableIcons={tableIcons3}
        selectedPeriod={selectedPeriod}
        searchInp={searchInp}
        selectedToDate={selectedToDate}
        selectedFromDate={selectedFromDate}
      />
    ),
    FA: (
      <FacillityMeetings
        tableIcons={tableIcons4}
        selectedPeriod={selectedPeriod}
        searchInp={searchInp}
        selectedToDate={selectedToDate}
        selectedFromDate={selectedFromDate}
      />
    ),
  };

  const meetingsComponent = tagComponents[activeTag] || null;

  useEffect(() => {
    const previousMonthFirstDate = moment()
      .subtract(1, "months")
      .startOf("month");
    const nextMonthLastDate = moment().add(1, "months").endOf("month");

    const formattedPreviousMonthFirstDate =
      previousMonthFirstDate.format("YYYY-MM-DD");
    const formattedNextMonthLastDate = nextMonthLastDate.format("YYYY-MM-DD");

    setSelectedFromDate(new Date(formattedPreviousMonthFirstDate));
    setSelectedToDate(new Date(formattedNextMonthLastDate));
  }, []);

  return (
    <div className="meeting-summary-main">
      {viewPastMeeting.isView ? (
        <ViewPastMeetings />
      ) : (
        <>
          <div
            className="uitility-container"
            data-testid="failedviewPastMeeting"
          >
            {/* <div>
                Select Period:
              </div> */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <div
                style={{ paddingLeft: "7px" }}
                // onBlur={() => setTimeout(() => { setOpenFromDatePicker(false) }, 500)}
                className="meet-summary-from-date-label-cont"
                data-testid="OpenFromDatePicker1"
                onClick={() => setOpenFromDatePicker(!openFromDatePicker)}
                onBlur={() =>
                  setTimeout(() => {
                    setOpenFromDatePicker(false);
                  }, 500)
                }
              >
                <label htmlFor="recstartDateFrom">From: </label>
                <div className="MSummary-from-date-cont">
                  <span
                    className="MSummary-calendar-icon"
                    style={{ padding: "5px 0px" }}
                    data-testid="recstartDateFrom1"
                    onClick={() =>
                      document.getElementById("recstartDateFrom")?.click()
                    }
                  >
                    <svg
                      id="calendar-line-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="14px"
                      height="14px"
                      viewBox="0 0 27.119 27.122"
                    >
                      <path
                        id="Path_15922"
                        data-name="Path 15922"
                        d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                        fill="#00aff1"
                      />
                    </svg>
                  </span>
                  <DatePicker
                    id="recstartDateFrom"
                    name="recEndDate"
                    style={{ color: "#B8B8B8" }}
                    // open={openFromDatePicker}
                    showTimeSelect={false}
                    maxDate={selectedToDate}
                    selected={selectedFromDate}
                    onChange={(date) =>
                      handleOnChange(
                        date,
                        selectedFromDate,
                        handleDateChange,
                        setSelectedFromDate,
                        setSelectedToDate
                      )
                    }
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
              </div>
              <div
                // onBlur={() => setTimeout(() => { setOpenToDatePicker(false) }, 500)}
                data-testid="ToOpenToDatePicker"
                onClick={() => setOpenToDatePicker(!openToDatePicker)}
                onBlur={() =>
                  setTimeout(() => {
                    setOpenToDatePicker(false);
                  }, 500)
                }
                className="meet-summary-to-date-label-cont"
              >
                <label>To: </label>
                <div className="MSummary-to-date-cont">
                  <span
                    className="MSummary-calendar-icon"
                    style={{ padding: "5px 0px" }}
                    data-testid="recEndDateToDiv"
                    onClick={() =>
                      document.getElementById("recEndDateTo")?.click()
                    }
                  >
                    <svg
                      id="calendar-line-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="14px"
                      height="14px"
                      viewBox="0 0 27.119 27.122"
                    >
                      <path
                        id="Path_15922"
                        data-name="Path 15922"
                        d="M18.011,1.044A1.176,1.176,0,0,1,19.285,0a1.176,1.176,0,0,1,1.273,1.044V5.617a1.176,1.176,0,0,1-1.273,1.044,1.176,1.176,0,0,1-1.273-1.044V1.044ZM14.59,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,14.807c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,18.859c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.548,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM3.5,22.911c-.075,0-.135-.316-.135-.706s.06-.706.135-.706H6.983c.075,0,.135.316.135.706s-.06.706-.135.706Zm5.546,0c-.075,0-.135-.316-.135-.706s.06-.706.135-.706h3.485c.075,0,.135.316.135.706s-.06.706-.135.706ZM6.535,1.044A1.176,1.176,0,0,1,7.808,0,1.176,1.176,0,0,1,9.082,1.044V5.617A1.176,1.176,0,0,1,7.808,6.661,1.176,1.176,0,0,1,6.535,5.617V1.044ZM1.412,10H25.7V4.738a.652.652,0,0,0-.19-.457.644.644,0,0,0-.457-.19H22.732a.706.706,0,0,1,0-1.412H25.06a2.065,2.065,0,0,1,2.059,2.059V25.062a2.065,2.065,0,0,1-2.059,2.059h-23A2.065,2.065,0,0,1,0,25.06V4.738A2.065,2.065,0,0,1,2.059,2.679H4.546a.706.706,0,1,1,0,1.412H2.059a.652.652,0,0,0-.457.19.644.644,0,0,0-.19.457V10Zm24.294,1.415H1.412V25.06a.652.652,0,0,0,.19.457.644.644,0,0,0,.457.19h23a.652.652,0,0,0,.457-.19.644.644,0,0,0,.19-.457V11.417ZM11.13,4.092a.706.706,0,0,1,0-1.412h4.743a.706.706,0,0,1,0,1.412Z"
                        fill="#00aff1"
                      />
                    </svg>
                  </span>
                  <DatePicker
                    id="recEndDateTo"
                    name="recEndDate"
                    style={{ color: "#B8B8B8" }}
                    // open={openToDatePicker}
                    minDate={selectedFromDate}
                    showTimeSelect={false}
                    selected={selectedToDate}
                    onChange={(date) =>
                      handleToDateChange(
                        date,
                        selectedToDate,
                        handleDateChange,
                        setSelectedFromDate,
                        setSelectedToDate
                      )
                    }
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <div className="search-box MSummary-search-box">
                <BsSearch
                  color="gray"
                  style={{ width: "26px", height: "14px" }}
                />
                <input
                  data-testid="searchInp1"
                  value={searchInp}
                  onChange={(e) => setSearchInp(e.target.value)}
                  type="text"
                  placeholder="Search"
                />
              </div>
            </div>

            {/* <button className="add-new-tag-btn">
                <AiOutlinePlus style={{ width: "20px", height: "20px" }} />
                <span>Add New Tag</span>
              </button> */}
          </div>

          <div className="meeting-summary-tabs">
            <ul className="meeting-summmary-nav-main">
              <div className="starting-div li-wraper "></div>
              <div className={"li-wraper"}>
                <li
                  className={
                    activeTag === "HR" ? "summary-active" : "summary-normal"
                  }
                  data-testid="handleActiveTagHR"
                  onClick={() => {
                    handleActiveTag("HR", setActiveTag, setSearchInp);
                  }}
                >
                  <span className={activeTag === "HR" ? "HRActiveSpan" : ""}>
                    HR
                  </span>
                </li>
              </div>
              <div className={"li-wraper"}>
                <li
                  className={
                    activeTag === "IT" ? "summary-active" : "summary-normal"
                  }
                  data-testid="handleActiveTagIT"
                  onClick={() => {
                    handleActiveTag("IT", setActiveTag, setSearchInp);
                  }}
                >
                  <span className={activeTag === "IT" ? "ITActiveSpan" : ""}>
                    IT
                  </span>
                </li>
              </div>
              <div className={"li-wraper"}>
                <li
                  className={
                    activeTag === "GO" ? "summary-active" : "summary-normal"
                  }
                  data-testid="handleActiveTagGO"
                  onClick={() => {
                    handleActiveTag("GO", setActiveTag, setSearchInp);
                  }}
                >
                  <span className={activeTag === "GO" ? "GOActiveSpan" : ""}>
                    Governance
                  </span>
                </li>
              </div>
              <div className={"li-wraper"}>
                <li
                  className={
                    activeTag === "FA" ? "summary-active" : "summary-normal"
                  }
                  data-testid="handleActiveTagFA"
                  onClick={() => {
                    handleActiveTag("FA", setActiveTag, setSearchInp);
                  }}
                >
                  <span className={activeTag === "FA" ? "FAActiveSpan" : ""}>
                    Facility
                  </span>
                </li>
              </div>
              <div className="ending-div li-wraper"></div>
            </ul>
          </div>

          <div
            className="meeting-summary-tabs-main"
            style={{
              paddingTop: "1px",
              borderLeft: "1px solid #D7D7D7",
              borderRight: "1px solid #D7D7D7",
              borderBottom: "1px solid #D7D7D7",
              width: "100%",
              overflowY: "scroll",
            }}
          >
            {meetingsComponent}
          </div>
        </>
      )}
    </div>
  );
};

export default MeetingSummary;
